module.exports = __webpack_public_path__ + "static/NazlyHilmyMsPharmPhD-d3f6a657c3607e5716c20bee456facf2.jpg";